import { Buildings, TrendUp, Receipt, ArrowSquareOut } from '@phosphor-icons/react';
import { formatCurrency } from '@/lib/utils';

export default function ClinicCard({ clinic, onClick }) {
  return (
    <div 
      className={`bg-white border border-[#E2E8F0] rounded-lg p-4 card-hover ${onClick ? 'cursor-pointer group' : ''}`}
      data-testid={`clinic-card-${clinic.name?.toLowerCase().replace(/\s+/g, '-')}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-[#E2E8F0]">
            <Buildings size={20} className="text-[#0F4C81]" weight="duotone" />
          </div>
          <h3 className="font-medium font-['Plus_Jakarta_Sans'] text-[#0F172A] text-sm">{clinic.name}</h3>
        </div>
        {onClick && <ArrowSquareOut size={14} className="text-[#64748B] opacity-0 group-hover:opacity-100 transition-opacity" />}
      </div>
      
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-xs text-[#64748B] flex items-center gap-1">
            <TrendUp size={14} />
            Revenue
          </span>
          <span className="text-sm font-medium text-[#0F4C81]">{formatCurrency(clinic.revenue)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-xs text-[#64748B] flex items-center gap-1">
            <Receipt size={14} />
            Invoices
          </span>
          <span className="text-sm font-medium">{clinic.invoice_count}</span>
        </div>
        {clinic.outstanding > 0 && (
          <div className="flex justify-between items-center">
            <span className="text-xs text-[#64748B]">Outstanding</span>
            <span className="text-sm font-medium text-[#DC2626]">{formatCurrency(clinic.outstanding)}</span>
          </div>
        )}
        <div className="flex justify-between items-center">
          <span className="text-xs text-[#64748B]">Avg. Ticket</span>
          <span className="text-sm font-medium">{formatCurrency(clinic.avg_ticket)}</span>
        </div>
      </div>
    </div>
  );
}
